/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  resetFieldForceMultiApprovalError,
  resetFieldForceMultiDeniedApprovalData,
  resetFieldForceMultiDeniedApprovalLoading,
} from "../../../redux/features/fieldForceTransaction";
import ICONS from "../../../assets/Icons";
import {
  getCreateTransactionBalance,
  resetOwnerBalance,
} from "../../../redux/features/owner/ownerAllVerification/ownerAllVerification";
import { GlobalConfiguration } from "../../../utils/configurationProvider";
import formatDateViewAll from "../../../utils/formatDateViewAll";
import TEXT from "../../../utils/globalText";
import SecondaryButton from "../../_utils/CommonButtons/SecondaryButton";
import SmallPopupWithInput from "../../_utils/CommonSmallPopupWithInput";
import CommonToast from "../../_utils/CommonToast";
import ApprovalTopNavComponent from "../../_utils/CommonTopNav/ApprovalTopNav";
import CardContainer from "../../_utils/CommonViewAllCard/CardContainer";
import TextWithBank from "../../_utils/CommonViewAllCard/CardSubComponent/TextWithBank";
import TextWithIcon from "../../_utils/CommonViewAllCard/CardSubComponent/TextWithIcon";
import TickerAnimation from "../../_utils/TickerAnimation";
import UniversalRefreshToast from "../../_utils/UniversalRefreshToast";
import Loader from "../../Loader/Index";
import {
  FieldForceMultiTxnDeniedApproval,
  FieldForceTxnMultiWaitingApproval,
} from "../../../redux/features/fieldForceTransaction";
import FieldForceTxnDetailsPopup from "../FieldForceTxnDetailsPopup";
import SmallPopupWithBulletPoints from "../../_utils/CommonSmallPopupWithBulletPoint";

const FieldForceTransactionMultiApprovalDetail = ({ state }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const conditionVarLengthZero = 0;
  const [txnId, setTxnId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [refreshId, setRefreshId] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [PrevBalance, setPrevBalance] = useState(null);
  const [failedRefreshId, setFailedRefreshId] = useState([]);
  const [refreshAnimation, setrefreshAnimation] = useState("");
  const [isApprovalError, setIsApprovalError] = useState(false);
  const [showTxnDetailPop, setShowTxnDetailPop] = useState(false);
  const [transactionFilterID, setTransactionFilterID] = useState([]);
  const [transactionFilterData, setTransactionFilterData] = useState([]);
  const { showReloginModal } = useSelector((state) => state.login);
  const services = useSelector((state) => state.refreshToken.services);

  const handleRefresh = (e, id, txnId, prevBalance) => {
    if (services?.includes("VAccountBalance") || services?.includes("Admin")) {
      e.stopPropagation();
      setPrevBalance(prevBalance);
      setrefreshAnimation(txnId);
      setRefreshId(txnId);
      setFailedRefreshId((prev) =>
        prev.filter((failedId) => failedId !== txnId),
      );

      dispatch(getCreateTransactionBalance(id));
    } else {
      e.stopPropagation();
      navigate("/feature_not_assigned");
    }
  };

  useEffect(() => {
    const storedSelectedApproval = JSON.parse(
      sessionStorage.getItem("selectedFieldForceTxnData"),
    );

    if (storedSelectedApproval) {
      setTransactionFilterData(
        storedSelectedApproval?.selectedSendTransactions || [],
      );
      setTransactionFilterID(storedSelectedApproval.selectedTransactions || []);
    } else {
      setTransactionFilterData([]);
      setTransactionFilterID([]);
    }
  }, []);

  const openBeneTxnDetailModal = () => {
    setShowTxnDetailPop(true);
  };
  const closeBeneTxnDetailModal = () => {
    setShowTxnDetailPop(false);
  };

  const {
    createTransactionBankRefreshLoading,
    createTransactionBankRefreshError,
    createTransactionBankRefreshData,
  } = useSelector((state) => state.ownerAllVerification);

  useEffect(() => {
    if (createTransactionBankRefreshLoading) {
      toast.dismiss();
      setTimeout(() => {
        UniversalRefreshToast();
      }, 200);
    } else if (createTransactionBankRefreshData?.status) {
      toast.dismiss();
      setTimeout(() => {
        CommonToast({
          text: "Balance refreshed successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }, 500);
      if (refreshAnimation) {
        setFailedRefreshId((prev) =>
          prev.filter((failedId) => failedId !== refreshAnimation),
        );
      }
    } else if (
      createTransactionBankRefreshError &&
      !createTransactionBankRefreshLoading
    ) {
      toast.dismiss();
      setTimeout(() => {
        CommonToast({
          text: createTransactionBankRefreshError,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
        });
      }, 100);
      if (refreshAnimation) {
        setFailedRefreshId((prev) => [...prev, refreshAnimation]);
      }
    }
    if (createTransactionBankRefreshData) {
      setTransactionFilterData((prev) => {
        const updated = prev.map((val) => {
          if (
            val.owner_account_id ===
            createTransactionBankRefreshData?.owner_accounts[0]
              ?.owner_account_id
          ) {
            return {
              ...val,
              owner_account_balance:
                createTransactionBankRefreshData?.owner_accounts[0]
                  ?.owner_account_balance,
              owner_account_balance_last_fetched_at_in_words:
                createTransactionBankRefreshData?.owner_accounts[0]
                  ?.owner_account_balance_last_fetched_at_in_words,
            };
          }
          return val;
        });

        const selectedData = {
          selectedSendTransactions: updated,
          selectedTransactions: transactionFilterID,
        };

        sessionStorage.setItem(
          "selectedFieldForceTxnData",
          JSON.stringify(selectedData),
        );
        return updated;
      });
    }
    return () => {
      dispatch(resetOwnerBalance());
    };
  }, [
    createTransactionBankRefreshData,
    createTransactionBankRefreshLoading,
    createTransactionBankRefreshError,
    dispatch,
    transactionFilterID,
    refreshAnimation,
  ]);

  let total = transactionFilterData?.reduce(
    (acc, { amount }) => acc + Number(amount || 0),
    0,
  );

  const handleOpenPopup = (id) => {
    setShowPopup(true);
  };
  const handleClosePopup = () => {
    setShowPopup(false);
  };
  const updateAllAccounts = (updatedAccounts) => {};

  const handleTxnApproval = async (id) => {
    setLoading(true);
    UniversalRefreshToast("Approving transaction.");

    if (transactionFilterID?.length) {
      dispatch(resetFieldForceMultiDeniedApprovalData());
      const data = await dispatch(FieldForceTxnMultiWaitingApproval(id));

      setTimeout(() => {
        setLoading(false);
        toast.dismiss();
        if (data?.payload?.status === 500) {
          setTimeout(() => {
            CommonToast({
              text: data?.payload?.error,
              icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
              variant: "var(--error)",
              buttonNeeded: false,
            });
          }, 1000);
        }
        if (data?.payload?.errors?.user_unauthorized?.[0]) {
          setTimeout(() => {
            navigate("/feature_not_assigned", {
              state: {
                unavailableService: "AFieldForceTxn",
              },
            });
          }, 1000);
        } else if (data.payload.status === true) {
          const selectedData = {
            selectedSendTransactions: data?.payload?.transactions,
            selectedTransactions: transactionFilterID,
          };

          sessionStorage.setItem(
            "selectedFieldForceTxnData",
            JSON.stringify(selectedData),
          );
          navigate("/field_force_transaction_dashboard/multi_approval/success");
        } else if (data?.payload?.response?.data?.status === false) {
          setIsApprovalError(true);
          navigate("/field_force_transaction_dashboard/multi_approval/error");
        }
      }, 2000);
    }
  };

  useEffect(() => {
    if (isApprovalError && showReloginModal === false) {
      navigate("/field_force_transaction_dashboard/multi_approval/error", {
        state: { type: "recreate_Multi" },
        replace: true,
      });
    }
  }, [navigate, showReloginModal, isApprovalError]);

  const isNoTransactionSelected =
    transactionFilterData.length === conditionVarLengthZero;
  const formatBankAccountNumber = (acc) => {
    if (!acc && acc !== 0) return acc;
    const s = String(acc)
      .replace(/\s+/g, "")
      .replace(/[^0-9]/g, "");
    if (!s) return acc;
    const rem = s.length % 4;
    const parts = [];
    let index = 0;
    if (rem !== 0) {
      parts.push(s.slice(0, rem));
      index = rem;
    }
    for (; index < s.length; index += 4) {
      parts.push(s.slice(index, index + 4));
    }
    return parts.join(" ");
  };
  const isSubmittingRef = useRef(false);

  const { BeneTxnDeniedApprovalLoading, BeneTxnMultiDeniedApprovalLoading } =
    useSelector((state) => state.beneTxnViewAccData);

  const [declineReason, setDeclineReason] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [inputDisabled, setInputDisabled] = useState(false);

  const handleInputChange = (event) => {
    let value = event.target.value;
    value = value.replace(/[^a-zA-Z0-9\s]/g, "");
    value = value.replace(/^\s+/, "");
    value = value.replace(/\s{2,}/g, " ");
    value = value.slice(0, 150);
    setDeclineReason(value);
  };

  const handleTxnMultiRejecting = () => {
    if (
      BeneTxnMultiDeniedApprovalLoading ||
      BeneTxnMultiDeniedApprovalLoading == null ||
      BeneTxnDeniedApprovalLoading
    ) {
      UniversalRefreshToast("Rejecting transaction.");
    }
    setTimeout(() => {
      toast.dismiss();
    }, 2000);
  };

  const finalize = () => {
    setShowLoader(false);
    setInputDisabled(false);
    setDeclineReason("");
    handleClosePopup();
  };

  const handleReject = async (id, reason) => {
    if (isSubmittingRef.current) return;
    isSubmittingRef.current = true;

    try {
      if (
        services?.find((service) => service === "AFieldForceTxn") !== undefined
      ) {
        if (!sessionStorage.getItem("q2p_token")) {
          return;
        }

        setShowLoader(true);
        setInputDisabled(true);
        handleTxnMultiRejecting();

        const apiCall = FieldForceMultiTxnDeniedApproval({
          id,
          AccountIdData: reason,
        });

        const result = await dispatch(apiCall);
        const payload = result?.payload;

        dispatch(resetFieldForceMultiApprovalError());
        dispatch(resetFieldForceMultiDeniedApprovalLoading());

        await new Promise((resolve) => setTimeout(resolve, 2000));

        if (payload?.status === 500) {
          CommonToast({
            text: payload?.error,
            icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
            variant: "var(--error)",
            buttonNeeded: false,
          });
          return finalize();
        }

        if (payload?.errors?.user_unauthorized?.[0]) {
          navigate("/feature_not_assigned", {
            state: { unavailableService: "AFieldForceTxn" },
          });
          return finalize();
        }

        if (payload?.status === false) {
          navigate("/field_force_transaction_dashboard/multi_approval/error");
        } else {
          navigate(
            "/field_force_transaction_dashboard/multi_approval/field_force_multi_transaction_declined",
          );
        }

        const updatedData = transactionFilterData.map((item) => {
          if (item.txn_id !== id) return item;

          const tx = payload?.transactions?.[0];
          let lifecycleStatus = "error";
          let errorMessage = "";

          if (payload?.status === true) {
            lifecycleStatus =
              tx?.lifecycle_status === "rejected"
                ? "rejected"
                : tx?.lifecycle_status === "pending"
                  ? "pendingOne"
                  : "error";
          }

          if (payload?.errors?.base?.[0]?.errors) {
            const errors = payload.errors.base[0].errors;
            errorMessage = errors[0];

            errors.forEach((msg) => {
              if (payload?.status === false) {
                CommonToast({
                  text: msg,
                  icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                  variant: "var(--error)",
                  buttonNeeded: false,
                });
              }
            });
          } else if (payload?.errors?.base?.[0]) {
            errorMessage = payload.errors.base[0];
          }

          return {
            ...item,
            lifecycle_status:
              item.lifecycle_status === "pending" && payload?.status === true
                ? lifecycleStatus
                : "error",
            rejected: true,
            rejection_reason: reason,
            error: payload?.status === false ? "true" : "false",
            message: payload?.status === false ? errorMessage : "",
          };
        });

        updateAllAccounts(updatedData);

        if (payload?.status === false) {
          const err =
            payload?.errors?.base?.[0]?.errors?.[0] ||
            payload?.errors?.base?.[0] ||
            "Error occurred";
          CommonToast({
            text: err,
            icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
            variant: "var(--error)",
            buttonNeeded: false,
          });
        } else {
          CommonToast({
            text: "Transaction rejected successfully.",
            icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
            variant: "var(--success)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });

          let storedData = JSON.parse(
            sessionStorage.getItem("selectedFieldForceTxnData"),
          );

          if (storedData) {
            const updatedTransactions =
              storedData.selectedSendTransactions?.filter(
                (txn) => txn.txn_id !== id,
              );

            const updatedTransactionIds =
              storedData.selectedTransactions?.filter((txnId) => txnId !== id);

            sessionStorage.setItem(
              "selectedFieldForceTxnData",
              JSON.stringify({
                ...storedData,
                selectedSendTransactions: updatedTransactions,
                selectedTransactions: updatedTransactionIds,
              }),
            );
          }

          setTimeout(() => {
            finalize();
          }, 3000);
        }

        finalize();
      } else {
        navigate("/feature_not_assigned", {
          state: {
            unavailableService: "AFieldForceTxn",
          },
        });
      }
    } finally {
      isSubmittingRef.current = false;
    }
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      const emojiRegex =
        /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g;

      if (emojiRegex.test(event.key)) {
        event.preventDefault();
        return;
      }

      if (event.key === "Enter") {
        event.preventDefault();
        event.stopPropagation();

        if (!inputDisabled && declineReason.trim().length >= 10) {
          handleReject(transactionFilterID, declineReason);
        }
      }

      if (event.key === "ArrowUp" || event.key === "ArrowDown") {
        event.preventDefault();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [inputDisabled, declineReason, transactionFilterID]);

  const [isFocused, setIsFocused] = useState(false);

  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;
    if (length === 0) return "default";
    if (length >= GlobalConfiguration.rejectReasonMinLength) {
      return "verified";
    }
    return focused ? "typing" : "error";
  };

  return (
    <>
      {showTxnDetailPop ? (
        <div
          className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity"
          onClick={() => {
            closeBeneTxnDetailModal();
          }}
        >
          <FieldForceTxnDetailsPopup
            closePopup={closeBeneTxnDetailModal}
            account_txn_id={txnId}
            type={"bene_txn_detail_modal"}
            typeSingle={"Additional_Details"}
            typeMulti={"MultiApproval_Session_Data"}
            TransactionHeader="Field force transaction details"
          />
        </div>
      ) : null}
      {showPopup ? (
        <div className="fixed top-top-base left-left-base w-full-width h-full-height z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <SmallPopupWithBulletPoints
            headerTitle={TEXT?.REJECT_REASON_TXN}
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            subtext={TEXT?.PROVIDE_REJECT_REQUEST_REASON_PROMPT}
            noteText={TEXT?.MINIMUM_TEN_CHARACTER_REQUIRED_MGS}
            isTextInputField={true}
            inputPlaceholder={TEXT?.REASON}
            subtextwithbullet="Y"
            inputAdornment={false}
            bulletPoints={[
              "Transaction will be rejected, and distribution will not be initiated.",
              "Transaction cannot be edited.",
            ]}
            inputOnFocus={(e) => setIsFocused(true)}
            inputOnBlur={(e) => setIsFocused(false)}
            inputVariant={computeVariant(declineReason, isFocused)}
            inputBgColor="var(--primary-bg)"
            inputFgColor="var(--text-secondary)"
            inputOnInput={(e) => {
              if (!showLoader) {
                handleInputChange(e);
              }
            }}
            inputValue={declineReason}
            inputFontKind="big"
            inputIsFullWidth={true}
            btnOneText={TEXT?.CANCEL}
            btnOneHandleFunction={() => {
              if (!showLoader) {
                setDeclineReason("");
                handleClosePopup();
              }
            }}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneHoverOption="white"
            btnOneIsDisabled={showLoader}
            btnTwoText={TEXT?.REJECT}
            btnTwoHandleFunction={() => {
              if (!declineReason || declineReason?.length < 10 || showLoader) {
                return;
              }
              handleReject(transactionFilterID, declineReason);
            }}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={!declineReason || declineReason?.length < 10}
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoIsLoaderNeeded={showLoader ? true : false}
            btnTwoIsLoading={showLoader ? true : false}
            btnTwoHoverOption="black"
            btnTwoInActiveVariantNeeded={true}
          />
        </div>
      ) : null}

      <div
        className="int-txn-mutli-details-main"
        style={{
          overflow: showPopup ? "hidden" : "",
          height: showPopup ? "var(--full-height)" : "",
        }}
      >
        {loading ? (
          <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
            <div className="flex justify-center items-center">
              <Loader />
            </div>
          </div>
        ) : null}
        <div className="hidden Qmd:block min-h-[var(--navbar-breadcrumb-height)] h-navbar-breadcrumb-height bg-primary-nav"></div>
        <div className="int-txn-mutli-container">
          <ApprovalTopNavComponent
            handleBack={() => navigate(-1)}
            topNavCtaBtn1Needed={false}
            topNavHeader={total}
            topNavSubText="Total amount"
            topNavCtaBtn1Props={{
              btnText: "Previous",
              btnType: "button",
              enabledBgColor: "var(--primary-nav-act)",
              handleFunction: () => navigate(-1),
              enabledTextColor: "var(--text-primary)",
              isDisabled: false,
              hoverOption: "white",
            }}
            topNavCtaBtn2Needed={false}
            topNavCtaBtnWithIcon1Props={{
              btnText: "Reject",
              handleFunction: () => {
                if (!isNoTransactionSelected) {
                  handleOpenPopup(transactionFilterID);
                }
              },
              enabledBgColor: "var(--failed)",
              enabledTextColor: "var(--text-primary)",
              icon: ICONS?.REJECT_ICON_RED_WITH_WHITE_CIRCLE,
              iconToBeAlign: "right",
              isDisabled: isNoTransactionSelected,
            }}
            topNavCtaBtnWithIcon2Props={{
              btnText: "Approve",
              handleFunction: () => {
                if (!isNoTransactionSelected) {
                  handleTxnApproval(transactionFilterID);
                }
              },
              enabledBgColor: "var(--positive-act)",
              enabledTextColor: "var(--text-primary)",
              icon: ICONS?.APPROVE_CIRCLE_GREEN_CHECKMARK,
              iconToBeAlign: "right",
              isDisabled: isNoTransactionSelected,
            }}
            BottomHeader={`Post approval process`}
            BottomSubText={`Once approved, transaction distribution will get created and auto settled using selected source account. If there are insufficient funds, the transaction will settle once the source account is refilled, and distribution will be initiated thereafter.`}
            isToggleNeeded={false}
            selectionBtnProps={{
              btnText: "View selected",
              btnType: "button",
              enabledBgColor: "var(--primary-nav-act)",
              handleFunction: () => {},
              enabledTextColor: "var(--text-primary)",
              isDisabled: false,
              icon: ICONS?.RELOAD_REFRESH_WHITE,
            }}
            iconComponentArray={[
              {
                enabledBgColor: "var(--primary-bg)",
                isLoading: loading,
                handleFunction: () => {},
                isDisabled: false,
                icon: ICONS?.RELOAD_REFRESH_WHITE,
                title: "Refresh schedules",
                hoverOption: "white",
              },
            ]}
            assignLabelNeeded={false}
            assignTagNeeded={false}
          />
        </div>
        <div className="int-txn-mutli-select-data-card">
          <div className="standard-card-alignment gap-gap-md ">
            {/* 6. FIXED: Added correct key iteration parameter here */}
            {transactionFilterData?.map((val, i) => {
              return (
                <div
                  className=""
                  key={val?.txn_id || i}
                >
                  <CardContainer
                    isDisabled={false}
                    isSelected={false}
                    isNoCursorRequired={true}
                    isNoHoverRequired={true}
                    onClickHandler={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    <card-body>
                      <TextWithIcon
                        type={
                          val.beneficiary_account_approval_status === "pending"
                            ? "Text"
                            : "Amount"
                        }
                        fontWeight={"semibold"}
                        text={
                          val.beneficiary_account_approval_status === "pending"
                            ? "Account approval pending"
                            : val?.amount
                        }
                        textColor={"var(--settled)"}
                        subText={
                          val.beneficiary_account_approval_status === "pending"
                            ? "Account status"
                            : "Amount"
                        }
                        iconComponentArray={
                          val.beneficiary_account_approval_status !== "pending"
                            ? [
                                ...(val?.confidential_transaction === "Y"
                                  ? [
                                      {
                                        icon: ICONS?.CONFIDENTIAL_TRANSACTION,
                                        title: "confidential",
                                        isDisabled: false,
                                      },
                                    ]
                                  : []),
                              ]
                            : []
                        }
                      />
                      <TextWithIcon
                        type={"Text"}
                        fontWeight={
                          val.beneficiary_account_approval_status === "pending"
                            ? "var(--font-normal)"
                            : "var(--font-semibold)"
                        }
                        text={
                          val.field_force_account_name
                            ?.toLowerCase()
                            ?.split(" ")
                            ?.map(
                              (word) =>
                                word.charAt(0).toUpperCase() + word.slice(1),
                            )
                            ?.join(" ") || "Not given"
                        }
                        textColor={"var(--text-primary)"}
                        subText="Account name"
                      />
                      <div className="relative">
                        <div className="flex flex-col gap-y-gap-xs pb-padding-button-l border-b-border mx-margin-sm border-primary-bg">
                          <div className="text-font-sm text-text-primary w-full truncate font-normal">
                            <TickerAnimation
                              text={
                                val.created_on
                                  ? formatDateViewAll(
                                      val.created_on,
                                      false,
                                      false,
                                    )
                                  : "Not given"
                              }
                            />
                          </div>
                          <div className="w-full flex justify-between items-center">
                            <p className="text-font-xs w-width-md text-text-secondary transform-none font-normal">
                              Date
                            </p>
                            <div className="z-z-index-overlay absolute right-right-base bottom-px">
                              <SecondaryButton
                                btnText={
                                  val.beneficiary_account_approval_status ===
                                  "pending"
                                    ? "Approve account"
                                    : "More details"
                                }
                                handleFunction={(e) => {
                                  e.stopPropagation();
                                  openBeneTxnDetailModal();
                                  setTxnId(val.txn_id);
                                }}
                                isDisabled={false}
                                enabledBgColor={"var(--text-primary)"}
                                enabledTextColor={"var(--primary-bg)"}
                                icon={ICONS?.ARROW_RIGHT_WHITE}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <TextWithBank
                        text={formatBankAccountNumber(
                          val.owner_account_bank_acc_no,
                        )}
                        type={""}
                        subText={"Source account"}
                        fontWeight={"normal"}
                        textColor={"var(--text-primary)"}
                        ifscCode={val?.owner_account_ifsc_code}
                      />

                      <TextWithIcon
                        type="Amount"
                        fontWeight={"semibold"}
                        text={
                          val?.owner_account_balance
                            ? val?.owner_account_balance
                            : "Not available"
                        }
                        subText={
                          "Balance - " +
                          (val?.owner_account_balance_last_fetched_at_in_words ||
                            "")
                        }
                        textColor={
                          Number(val?.owner_account_balance) >=
                          Number(val?.amount)
                            ? "var(--settled)"
                            : "var(--failed)"
                        }
                        iconComponentArray={[
                          ...(function () {
                            let iconUrl = "";
                            let titleText = "";

                            if (
                              createTransactionBankRefreshLoading &&
                              refreshId === val?.txn_id
                            ) {
                              iconUrl = ICONS?.LOADER_GIF;
                              titleText = "Balance updating";
                            } else if (failedRefreshId.includes(val?.txn_id)) {
                              iconUrl = ICONS?.ERROR_WITH_ORANGE_CIRCLE;
                              titleText = "Balance fetch failed";
                            } else if (
                              !createTransactionBankRefreshLoading &&
                              refreshId === val?.txn_id &&
                              refreshAnimation === val?.txn_id &&
                              PrevBalance !== undefined &&
                              Number(val?.owner_account_balance) !==
                                Number(PrevBalance)
                            ) {
                              if (
                                Number(val?.owner_account_balance) >
                                Number(PrevBalance)
                              ) {
                                iconUrl = ICONS?.ARROW_UP_GREEN_GIF;
                                titleText = "Balance updated";
                              } else if (
                                Number(val?.owner_account_balance) <
                                Number(PrevBalance)
                              ) {
                                iconUrl = ICONS?.ARROW_DOWN_RED_GIF;
                                titleText = "Balance updated";
                              }
                            }

                            return iconUrl
                              ? [
                                  {
                                    icon: iconUrl,
                                    title: titleText,
                                    isDisabled: false,
                                  },
                                ]
                              : [];
                          })(),

                          {
                            icon: ICONS?.RELOAD_REFRESH_WHITE,
                            title: "Refresh balance",
                            isDisabled: !(
                              services?.includes("VAccountBalance") ||
                              services?.includes("Admin")
                            ),
                            onClick: (e) => {
                              if (
                                !createTransactionBankRefreshLoading ||
                                refreshId !== val?.txn_id
                              ) {
                                if (
                                  services?.includes("VAccountBalance") ||
                                  services?.includes("Admin")
                                ) {
                                  handleRefresh(
                                    e,
                                    val?.owner_account_id,
                                    val?.txn_id,
                                    val?.owner_account_balance,
                                  );
                                } else {
                                  e.stopPropagation();
                                  navigate("/feature_not_assigned", {
                                    state: {
                                      unavailableService:
                                        "VAccountBalance,Admin",
                                    },
                                  });
                                }
                              } else {
                                e.stopPropagation();
                              }
                            },
                            bgColor: "var(--primary-nav)",
                          },
                        ]}
                      />

                      <TextWithIcon
                        text={val?.labels?.join(", ") || "Not assigned"}
                        fontWeight={"normal"}
                        textColor={"var(--text-primary)"}
                        iconComponentArray={[
                          {
                            icon: ICONS?.LABEL,
                          },
                        ]}
                      />
                    </card-body>
                  </CardContainer>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default FieldForceTransactionMultiApprovalDetail;
